<template>
    <div class="c-course-card flex flex-column flex-between">
        <div
            :class="[
                'flex',
                'flex-item',
                'flex-column',
                'flex-' + bodyFlex,
                'c-course-card-container'
            ]"
        >
            <div>
                <c-title :name="name" :tags="tags"></c-title>
                <div v-if="showCourseTime" class="mt14">
                    <div class="c-course-card-row">
                        {{ courseTime ? courseTime : '已结束，可看录播' }}
                    </div>
                    <!-- <div class="c-course-card-row">课时：28课</div> -->
                </div>
                <div v-else class="c-course-card-row mt23">{{ playCount }}次播放</div>
            </div>
            <div class="flex flex-between flex-vertical-end mt28">
                <c-avatar :avatar="avatar" :username="username"></c-avatar>
                <c-tag v-if="state === 3" color="green" class="c-course-card-state">
                    <i class="el-icon-s-data"></i>
                    <span>正在直播</span>
                </c-tag>
                <img v-else-if="bought" v-lazy="sign" class="c-course-card-img" />
            </div>
        </div>
        <div v-if="audition" class="flex flex-vertical-center flex-row-center c-course-card-footer">
            <c-button class="c-course-card-btn" color="purple">免费试听</c-button>
        </div>
        <div v-else class="flex flex-vertical-center flex-between c-course-card-footer">
            <div class="c-course-card-row">{{ playCount }}次{{ statusText }}</div>
            <div v-if="free" class="c-course-card-text">免费</div>
            <div v-else-if="bought" class="c-course-card-text">
                <c-button color="purple">去听课</c-button>
            </div>
            <div v-else-if="price" class="c-course-card-text">
                {{ price | priceFilter }}
            </div>
        </div>
    </div>
</template>

<script>
import CTitle from '@components/CTitle.vue';
import CAvatar from '@components/CAvatar.vue';
import CButton from '@components/CButton.vue';
import CTag from '@components/CTag.vue';
import sign from '@images/sign.png';

export default {
    components: {
        CTitle,
        CAvatar,
        CButton,
        CTag
    },
    props: {
        /**
         * 显示课时
         */
        showCourseTime: {
            type: Boolean,
            default: true
        },
        courseTime: {
            type: String,
            default: ''
        },
        bodyFlex: {
            type: String,
            default: 'between',
            validator: (val) => ['between', 'start'].includes(val)
        },
        name: {
            type: String,
            required: true
        },
        statusText: {
            type: String,
            default: '播放'
        },
        tags: {
            type: Array,
            required: true
        },
        playCount: {
            type: Number,
            required: true
        },
        avatar: {
            type: String,
            required: true
        },
        username: {
            type: String,
            required: true
        },
        free: {
            type: Boolean,
            default: true
        },
        /**
         * 试听
         */
        audition: {
            type: Boolean,
            default: false
        },
        price: {
            type: Number,
            default: 0
        },
        bought: {
            type: Boolean,
            default: false
        },
        /**
         * 课程状态
         */
        state: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            sign: sign
        };
    }
};
</script>

<style lang="scss" scoped>
.c-course-card {
    width: 100%;
    height: 354px;
    background-color: #ffffff;
    border-radius: 4px;
    box-sizing: border-box;
    box-shadow: 0px 5px 27px 0px #eaebee;
    cursor: pointer;
    &-container {
        padding: 27px 21px 10px;
    }
    &-btn {
        padding: 13px 75px;
    }
    &-row {
        font-size: 14px;
        color: #888888;
        text-align: left;
        & + & {
            margin-top: 9px;
        }
    }
    &-img {
        transform: translateY(20px);
    }
    &-footer {
        height: 90px;
        box-sizing: border-box;
        border-top: 1px solid #e5e5e5;
        padding-left: 21px;
        padding-right: 21px;
    }
    &-text {
        color: #7f008f;
        font-size: 18px;
    }
    &-state {
        font-size: 12px;
        padding: 6px 13px;
    }
}
</style>
